import { MAX_NAME_LENGTH } from '@/shared/config';
import { InferType, object, string, date } from '@/shared/config/yup';

export const editAlbumFormSchema = object({
  albumName: string().optional().max(MAX_NAME_LENGTH),
  albumTime: date().required(),
}).required();

export type EditAlbumFormPayload = InferType<typeof editAlbumFormSchema>;
